// extracted by mini-css-extract-plugin
export default {"container":"CommandsRewardsPage_container__DJdZC","item":"CommandsRewardsPage_item__kZugs","deletebutton":"CommandsRewardsPage_deletebutton__O1QCw"};